<!--
  画面名：-
  概要： システム設定、管理機能のタイトルのコンポーネント
  備考： -
-->

<template>
  <!-- ページタイトル -->
  <div class="pagetitle">
    <h1>{{ PageTitle }}</h1>
  </div>
</template>

<script>
export default {
  // 親コンポーネントから値を取得
  props: {
    // 親コンポーネントから取得したページタイトル
    PageTitle: String
  }
}
</script>
